import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import './HistoricoAndaimes.css';

const HistoricoAndaimes = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [registos, setRegistos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filtro, setFiltro] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.get('/andaimes');
                setRegistos(response.data || []);
            } catch (err) {
                console.error('Erro ao carregar histórico:', err);
                setError('Não foi possível carregar o histórico.');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleViewPdf = async (id) => {
        try {
            const response = await api.get(`/andaimes/relatorio/${id}`, { responseType: 'blob' });
            const blob = response.data;
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
        } catch (err) {
            console.error('Erro ao abrir PDF:', err);
            alert('Não foi possível abrir o PDF.');
        }
    };

    const handleShare = async (id, shareToken) => {
        const pdfUrl = window.location.origin + `/api/andaimes/relatorio/${id}` + (shareToken ? `?t=${shareToken}` : '');
        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'Relatório de Verificação de Andaime',
                    text: 'Consulte o relatório neste link:',
                    url: pdfUrl
                });
            } catch (err) {
                console.error('Partilha cancelada:', err);
            }
        } else {
            window.open(pdfUrl, '_blank');
        }
    };

    const registosFiltrados = registos.filter(r => {
        if (!filtro) return true;
        const termo = filtro.toLowerCase();
        return (
            (r.relatorio_num || '').toLowerCase().includes(termo) ||
            (r.obra_nome || '').toLowerCase().includes(termo) ||
            (r.equip_nome || '').toLowerCase().includes(termo) ||
            (r.nome_tecnico || '').toLowerCase().includes(termo)
        );
    });

    return (
        <div className="historico-andaimes-container">
            <div className="top-bar">
                <div className="top-bar-left">
                    <div className="top-bar-title">
                        <h1>📋 Histórico de Andaimes</h1>
                        <p className="mobile-hide">Consulte todos os relatórios de verificação</p>
                    </div>
                </div>
                <div className="top-bar-actions">
                    {!user?.perfil_mobile && (
                        <button className="btn-secondary" onClick={() => navigate(-1)}>
                            ← Voltar
                        </button>
                    )}
                    {user?.perfil_mobile && (
                        <button className="btn-secondary" onClick={() => navigate('/mobile-dashboard')}>
                            ← Menu
                        </button>
                    )}
                </div>
            </div>

            <div className="page-content" style={{ padding: '20px' }}>
                <div className="ha-content-wrapper">
                    <div className="ha-search">
                        <input
                            type="text"
                            placeholder="🔍 Pesquisar por obra, equipamento, técnico..."
                            value={filtro}
                            onChange={(e) => setFiltro(e.target.value)}
                        />
                    </div>

                    {error && <div className="ha-error">{error}</div>}

                    {loading ? (
                        <div className="ha-loading">A carregar...</div>
                    ) : registosFiltrados.length === 0 ? (
                        <div className="ha-empty">
                            <p>Nenhum registo de verificação encontrado.</p>
                            <button className="ha-new-btn" onClick={() => navigate('/andaime-verificacao')}>
                                + Nova Verificação
                            </button>
                        </div>
                    ) : (
                        <div className="ha-list">
                            {registosFiltrados.map(r => (
                                <div key={r.id} className="ha-card">
                                    <div className="ha-card-header">
                                        <span className="ha-num">{r.relatorio_num}</span>
                                        <span className={`ha-resultado ${r.resultado_usavel ? 'apto' : 'nao-apto'}`}>
                                            {r.resultado_usavel ? '✅ Apto' : '❌ Não Apto'}
                                        </span>
                                    </div>
                                    <div className="ha-card-body">
                                        <div className="ha-info-row">
                                            <span className="ha-label">🏗️ Obra:</span>
                                            <span>{r.obra_nome || '-'}</span>
                                        </div>
                                        <div className="ha-info-row">
                                            <span className="ha-label">🪜 Equip.:</span>
                                            <span>{r.equip_nome || '-'}</span>
                                        </div>
                                        <div className="ha-info-row">
                                            <span className="ha-label">👷 Técnico:</span>
                                            <span>{r.nome_tecnico || '-'}</span>
                                        </div>
                                        <div className="ha-info-row">
                                            <span className="ha-label">📅 Data:</span>
                                            <span>{r.data_verificacao ? new Date(r.data_verificacao).toLocaleDateString('pt-PT') : '-'}</span>
                                        </div>
                                    </div>
                                    <div className="ha-card-actions">
                                        <button className="ha-btn ha-btn-pdf" onClick={() => handleViewPdf(r.id)}>
                                            🖨️ Ver PDF
                                        </button>
                                        <button className="ha-btn ha-btn-share" onClick={() => handleShare(r.id, r.share_token)}>
                                            📤 Partilhar
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="ha-footer-action">
                        <button className="ha-new-btn" onClick={() => navigate('/andaime-verificacao')}>
                            + Nova Verificação
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HistoricoAndaimes;
